import { useState, useEffect, useRef } from 'react'

// Counts a stat up from 0 once its value arrives; keeps any "$" prefix and decimals
const CountUp = ({ value }) => {
  const text = String(value)
  const match = text.match(/^(\D*)([\d,]+(?:\.\d+)?)(.*)$/)
  const target = match ? parseFloat(match[2].replace(/,/g, '')) : NaN
  const decimals = match && match[2].includes('.') ? match[2].split('.')[1].length : 0
  const grouped = match ? match[2].includes(',') || text.startsWith('$') : false
  const [current, setCurrent] = useState(0)
  const frame = useRef(null)

  useEffect(() => {
    if (!Number.isFinite(target)) return
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduce || target === 0) {
      setCurrent(target)
      return
    }
    const start = performance.now()
    const duration = 900
    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1)
      setCurrent(target * (1 - Math.pow(1 - t, 3)))
      if (t < 1) frame.current = requestAnimationFrame(tick)
    }
    frame.current = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame.current)
  }, [target])

  if (!match) return text
  const number = grouped
    ? current.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    : current.toFixed(decimals)
  return `${match[1]}${number}${match[3]}`
}

export default CountUp
